import React from 'react';
import { useTrackError } from 'hooks/useAnalytics';
import styled from '@emotion/styled';
import { Alert } from '@qbe/ads-core';
import { Theme } from '@mui/material';
import { useContentContext } from '@qbe/dfc-content';
import { useContentComplaintPartners } from 'utils/content';
import noop from 'lodash/noop';

interface AlertBannerProps {
  onClose?: (e: object) => void;
  show: boolean;
  errorMsg?: string | React.ReactNode | null;
  title?: string | null;
}

const StyledAlert = styled(Alert)`
  --width-content: 600px;
  --width-content-mobile: 345px;

  width: var(--width-content);

  ${({ theme }) => `${(theme as Theme).breakpoints.down('md')} {
      width: var(--width-content-mobile);
    }`}
`;

const AlertBanner = ({ errorMsg = null, title = null, show = true, onClose = noop }: AlertBannerProps) => {
  window.scrollTo(0, 0);

  const { getTextContent } = useContentComplaintPartners({ context: useContentContext() });

  const defaultErrorMsg = getTextContent('alertBanner.defaultErrorMsg');
  const defaultTitle = getTextContent('alertBanner.defaultTitle');

  const error = typeof errorMsg === 'string' ? errorMsg : title || defaultErrorMsg;
  useTrackError(show, error);

  return show ? (
    <StyledAlert heading={title || defaultTitle} variant={'warning'} onClose={onClose}>
      {errorMsg || defaultErrorMsg}
    </StyledAlert>
  ) : null;
};
export default AlertBanner;
